// removed by extract-text-webpack-plugin
module.exports = {"Button":"src-components-Button----Button-module---Button---1lSPX","Primary":"src-components-Button----Button-module---Primary---3suM_","PrimaryButtonLoading":"src-components-Button----Button-module---PrimaryButtonLoading---3xicQ","PrimaryButtonDisabled":"src-components-Button----Button-module---PrimaryButtonDisabled---2iIO_","Secondary":"src-components-Button----Button-module---Secondary---3FwkJ","Transparent":"src-components-Button----Button-module---Transparent---1lisK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.module.css
// module id = 36
// module chunks = 35783957827783 114276838955818 223089570075972 244214548324586